export default __webpack_public_path__ + "images/GettingThere.v-c81779728d60fe412fde8e771d1d507d.svg";